import { render } from "./territory-table.vue?vue&type=template&id=11a2fc38"
import script from "./territory-table.vue?vue&type=script&lang=js"
export * from "./territory-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__